import { render, staticRenderFns } from "./QuestionsCategoriesPage.vue?vue&type=template&id=747004b4&"
import script from "./QuestionsCategoriesPage.vue?vue&type=script&lang=js&"
export * from "./QuestionsCategoriesPage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsCategoriesPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports